module.exports = __webpack_public_path__ + "media/images/img_service_merit_2-1328988992614476ec8d1091c605622f.png";